import COLORS from './colors';

export { COLORS };
